import { isBeverageDataValid } from "./utils";

export const buildPendingBeverageV7Selections = ({
  categories = [],
  categoriesDetails = {},
  pendingDetails = null,
  continueToPersonalize = false,
}) => {
  const detailsToSave = pendingDetails || categoriesDetails;
  const hasValidPreferences =
    categories.length > 0 && isBeverageDataValid(detailsToSave);

  return {
    categories,
    categoriesDetails: detailsToSave,
    shouldAutoSavePreferences: hasValidPreferences,
    continueToPersonalize,
    /**
     * Lets the acid-change guard in beverageSession.js recognize this as
     * this exact redirect's own in-flight data rather than leftover
     * cross-guest state, so it isn't wiped before this page restores it.
     */
    timestamp: Date.now(),
  };
};

export const getBeverageV7PostPreferenceSaveState = ({
  continueToPersonalize,
  hasAnsweredConsent,
}) => {
  if (!continueToPersonalize) {
    return null;
  }

  return hasAnsweredConsent ? "success" : "consent";
};
